module.exports = __webpack_public_path__ + "static/blog28-3df33522dc5c7ae1a4931a4713843172.png";